var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 105,
    viewBox: "0 0 231 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2707_29984)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 105,
    fill: "#111010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5449L6.75316 38.0984C11.5962 34.7444 16.39 31.4726 21.0112 28.3787C25.9159 24.9973 29.5143 22.6975 32.0282 21.3422L32.1515 21.2737H33.2606L33.2852 21.9445C33.4084 25.5997 33.4084 30.0899 33.4084 35.292V48.0508C33.4084 63.5065 33.2729 75.704 33.162 83.5345C33.1127 87.4224 33.0634 90.7216 33.0141 93.4184C32.9648 96.526 32.9278 98.8533 32.9155 100.359H52.5835C52.4726 97.4843 52.3616 91.2007 52.3616 81.2894C52.2384 70.6388 52.2384 61.6994 52.2384 53.8141C52.2384 51.2131 52.2384 45.1212 52.3616 35.8533C52.4849 26.6675 52.5958 10.4178 52.6081 1.17725H33.7288C31.2272 2.95691 28.0232 5.27047 24.1167 8.11792C16.1312 13.936 7.94852 19.9184 0 25.5449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.799 86.8885C116.528 86.8885 116.257 86.9296 115.973 86.9296C112.215 86.9296 108.776 86.2177 105.757 84.8214C102.504 83.3703 99.8544 81.4948 97.6732 79.058C94.3952 75.5535 91.8689 71.296 90.3778 66.7647C88.9483 62.384 88.1227 56.8123 88.1227 51.4733C88.1227 46.1343 88.9237 41.3155 90.5011 36.5926C92.1524 31.6506 94.4075 27.6532 97.1803 24.6962C99.3862 22.2458 102.097 20.1512 104.993 18.6864C107.939 17.1943 112.079 16.2907 116.097 16.2907C120.114 16.2907 123.54 17.0026 126.682 18.399C129.664 19.7269 132.351 21.7392 134.902 24.573C137.983 27.9954 140.201 32.0202 141.704 36.8801C142.173 38.2764 142.542 39.7275 142.875 41.206L155.063 19.8501C153.67 17.8103 152.13 15.8664 150.429 14.0456C146.104 9.51434 141.039 6.02347 135.358 3.65515C129.418 1.23207 122.899 0 115.986 0C109.072 0 102.75 1.28683 96.4902 3.92894C90.5627 6.47523 85.4485 10.1167 81.3079 14.7301C77.0071 19.3846 73.6921 24.8742 71.4616 31.0619C69.2557 37.1949 68.1836 43.9166 68.1836 51.6102C68.1836 59.3038 69.379 66.2855 71.8313 72.8429C74.2836 79.3866 77.7834 84.9857 82.5279 89.9961C86.8287 94.3631 91.8566 97.7171 97.476 99.9759C100.914 101.331 104.278 102.262 107.729 102.823L116.824 86.8885H116.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.148 104.315H198.342L145.352 11.6362L151.267 15.1956L155.05 19.8501L203.148 104.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.35 104.316H210.544L154.461 6.27002H159.267L215.35 104.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.414 46.1343L168.151 63.1095L161.004 51.1995L130.195 105H160.018L193.414 46.1343Z",
    fill: "#BDF15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.999 2.57373H201.743L163.344 71.0496H179.487L191.441 50.3782L198.958 61.8775L230.999 2.57373Z",
    fill: "#BDF15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.286 76.5255L174.067 80.3586L150.16 37.5098L152.748 33.5398L176.286 76.5255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.671 104.316H222.865L182.938 36.1408L185.649 31.4863L227.671 104.316Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2707_29984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 105,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a91dd3da73ca7c492cb584c11f99f9e.svg";
export { ForwardRef as ReactComponent };